import React from "react";
import FacebookIcon from "@mui/icons-material/Facebook";

const FacebookButton = () => (
  <a
    className="floating-social-link floating-social-link--facebook"
    href="https://www.facebook.com/share/198pPFWyX1/?mibextid=wwXIfr"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Visit us on Facebook"
    title="Facebook"
    style={{
      backgroundColor: "#1877F2",
      color: "white",
    }}
  >
    <FacebookIcon style={{ fontSize: 35 }} />
  </a>
);

export default FacebookButton;
